<div class="row align-items-start mb-4">
    <div class="col-auto">
        <app-back-button></app-back-button>
    </div>
    <div class="col-auto mx-auto">
        <h5>{{ "PAGES.SELECT-CATEGORY" | translate }}</h5>
    </div>
    <div class="col-auto" style="width: 120px"></div>
</div>
<app-tournament-categories
    [selection]="true"
    (onSelectionChange)="selectedCategory = $event"
></app-tournament-categories>
<div class="d-flex justify-content-center mt-3">
    <button nbButton status="primary" [disabled]="!selectedCategory" [routerLink]="['../', selectedCategory, 'enroll']">
        {{ "BUTTONS.GO" | translate }} <nb-icon icon="arrow-forward-outline"></nb-icon>
    </button>
</div>
